// extracted by mini-css-extract-plugin
module.exports = {"CardDetails":"CardDetails_CardDetails__2HW1o","InputWrapper":"CardDetails_InputWrapper__15tcd","checkboxWrapper":"CardDetails_checkboxWrapper__2M4Zs"};